import "react-big-calendar/lib/css/react-big-calendar.css";

import InstructorsGroupManager from "../../components/APanel/InstructorsGroupManager";

function APInstrGroups() {
   return (
      <>
         <main className="main">
            <section className="page-wrapper">
               <InstructorsGroupManager />
            </section>
         </main>
      </>
   );
}

export default APInstrGroups;
